export const styles = {
  stats: {
    justifyContent: 'space-between',
    flexGrow: 0,
    flexShrink: 0,
    px: 2.75,
    pt: 1,
    pb: 3,
  },
};
